<template>
    <SkillsReadOnly
        v-if="hasTopSkills"
        class="profile-header-section__top-skills"
        data-testid="profile-header-section-top-skills"
        :skills="topSkillsToSkills!"
        :is-visible-seo-link="false"
        :is-enabled-tooltip="false"
        :is-visible-translated-label="isVisibleTranslatedLabel"
        gap="small"
        @clicked="editTopSkills"
    />
    <VJoyTag
        v-else
        variant="secondary"
        class="profile-header-section__top-skills-add"
        data-testid="profile-header-section-top-skills-empty-add-cta"
        @click="editTopSkills"
    >
        <VJoyIcon name="add" />
        {{ $t('profile.section.skill.set.edition.topskills.add') }}
    </VJoyTag>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyTag, VJoyIcon} from '@maltjoy/core-vue';
    import type {Skill} from '@api';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';
    import {useTranslationStore} from '~/store/translation/translationStore';
    import SkillsReadOnly from '@/components/_common/skills/SkillsReadOnly.vue';
    import {useSkillSetStore} from '@/store/skill-set/skillSetStore';

    const {profileTopSkills} = storeToRefs(useSkillSetStore());
    const hasTopSkills = computed(() => profileTopSkills.value && profileTopSkills.value.length > 0);
    const topSkillsToSkills = computed<readonly Skill[]>(() => profileTopSkills.value);

    const {isTranslationActivated, isTranslationDone} = storeToRefs(useTranslationStore());
    const isVisibleTranslatedLabel = computed((): boolean => isTranslationActivated.value && isTranslationDone.value);

    function editTopSkills() {
        eventBus.emit('header:edit-mode', {entryPoint: EditionOpenedEntryPoint.PROFILE_PAGE, scrollToElement: 'edit-header-top-skills'});
    }
</script>
<style lang="scss">
    .profile-header-section__top-skills-add {
        cursor: pointer;
    }
</style>
